import React from "react";
import Footer from "./component/Footer";
function Pricing() {
  return (
    <div className="Pricing">
      <main className="font-nunito">
        {/* Jumbotron Section Start Here */}
        <section className="pt-16">
          <div id="jumbotron">
            <img className="w-full" src="./img/pricing.webp" alt="" />
          </div>
        </section>
        {/* Jumbotron Section End Here */}
        <section className="pb-28">
          <div class="min-h-screen  bg-white  flex flex-col flex-wrap items-center  justify-center  ">
            <div className="">
              <h2 className="text-heading-color text-4xl pt-11 font-bold text-center">
                PRICING
              </h2>
              <h3 className="text-dark-grey font-bold text-center">
                CHOOSE YOUR BEST PLAN
              </h3>
              <div className="flex justify-center  mt-6 mb-24">
                <p className="font-poppins font-bold text-xs">MONTHLY</p>
                <div class="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in ml-8 mr-8">
                  <input
                    type="checkbox"
                    name="toggle"
                    id="toggle"
                    class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-main-color border-4 appearance-none cursor-pointer"
                  />
                  <label
                    for="toggle"
                    class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
                  ></label>
                </div>
                <p className="font-poppins font-bold text-xs ">
                  YEARLY{" "}
                  <span className="font-roboto text-main-color underline">
                    {" "}
                    Save 30%
                  </span>
                </p>
              </div>
            </div>
            <div class="flex flex-col sm:flex-col lg:flex-row xl:flex-row lg:flex-row justify-center items center  container   ">
              <div class="py-12 sm:py-12 lg:py-6 lg:py-6 xl:py-6 px-8 w-full lg:w-1/4 sm:w-full bg-white border z-1">
                <div class="flex justify-center items-center flex-col py-4 px-7">
                  <img src="./img/plane.png" alt="" />
                  <p class="text-pricing-blue  font-bold mt-6">$ 00.0</p>
                  <h3 className="text-pricing-blue font-poppins font-bold text-base mt-6">
                    FREE PLAN
                  </h3>
                  <p className="font-roboto text-sm text-gray-600">
                    For free basic product feature
                  </p>
                </div>

                <div class="text-center xs:text-center sm:text-center lg-text-center lg:text-left mt-3 font-roboto">
                  <ul id="pricing" class=" text-sm text-gray-400">
                    <li className="text-black">
                      <span className="mr-4 text-check-mark text-base">✔</span>{" "}
                      <p>5 GB of free space</p>
                    </li>
                    <li className="text-black">
                      {" "}
                      <span className="mr-4 text-check-mark text-base">
                        ✔
                      </span>{" "}
                      <p>30 days of free service</p>
                    </li>
                    <li>
                      <span className="mr-4 text-gray-400 text-base">✔</span>{" "}
                      <p className="line-through">
                        All time support service 24/7
                      </p>
                    </li>
                    <li>
                      <span className="no-underline mr-4 text-gray-400 text-base">
                        ✔
                      </span>{" "}
                      <p className="line-through">
                        Access to free learning courses
                      </p>
                    </li>
                    <li>
                      <span className="mr-4 text-gray-400 text-base">✔</span>{" "}
                      <p className="line-through">
                        Certificate of project completion
                      </p>
                    </li>
                    <li>
                      <span className="mr-4 text-gray-400 text-base">✔</span>{" "}
                      <p className="line-through">
                        Advance loan payment feature
                      </p>
                    </li>
                  </ul>
                </div>
                <button class="font-poppins w-full mt-6 mb-3 py-4 text-sm text-white font-semibold bg-pricing-blue rounded-md hover:shadow-xl duration-200 hover:bg-gray-800">
                  <a href="#">GET STARTED</a>
                </button>
              </div>
              <div class="py-12 sm:py-12 lg:py-6 lg:py-6 xl:py-6 px-8 w-full lg:w-1/4 sm:w-full bg-pricing-pink transform scale-1 sm:scale-1 lg:scale-105 lg:scale-105 xl:scale-105 z-2  shadow-none sm:shadow-none lg:shadow-xl lg:shadow-xl xl:shadow-xl">
                <div class="flex justify-center  items-center flex-col py-4 px-7">
                  <img src="./img/airplane.png" alt="" />
                  <p class="text-white mt-6 font-bold">$9.99</p>
                  <h3 className="text-white font-poppins font-bold text-base mt-6">
                    PROFESSIONAL PLAN
                  </h3>
                  <p className="font-roboto text-sm text-white">
                    For minimal product feature
                  </p>
                </div>

                <div class="text-center xs:text-center sm:text-center lg-text-center lg:text-left mt-3 font-roboto">
                  <ul id="pricing" class=" text-sm text-white">
                    <li>
                      <span className="mr-4 text-white text-base">✔</span>{" "}
                      <p>1000 GB of free space</p>
                    </li>
                    <li>
                      {" "}
                      <span className="mr-4 text-white text-base">✔</span>{" "}
                      <p>30 days of free service</p>
                    </li>
                    <li>
                      <span className="mr-4 text-white text-base">✔</span>{" "}
                      <p>All time support service 24/7</p>
                    </li>
                    <li>
                      <span className="no-underline mr-4 text-white text-base">
                        ✔
                      </span>{" "}
                      <p>Access to free learning courses</p>
                    </li>
                    <li>
                      <span className="mr-4 text-gray-400 text-base">✔</span>{" "}
                      <p className="line-through text-gray-400">
                        Certificate of project completion
                      </p>
                    </li>
                    <li>
                      <span className="mr-4 text-gray-400 text-base">✔</span>{" "}
                      <p className="line-through text-gray-400">
                        Advance loan payment feature
                      </p>
                    </li>
                  </ul>
                </div>
                <button class="font-poppins w-full mt-6 mb-3 py-4 text-sm text-pricing-pink font-semibold bg-white rounded-md hover:shadow-xl duration-200 hover:bg-gray-800">
                  <a href="#">GET STARTED</a>
                </button>
              </div>
              <div class="py-10 sm:py-12 lg:py-6 lg:py-6 xl:py-6 px-8 w-full lg:w-1/4 sm:w-full bg-white border z-1">
                <div class="flex justify-center  items-center flex-col py-4 px-4">
                  <img src="./img/rocket.png" alt="" />
                  <p class="text-main-color font-bold mt-6">$14.99</p>
                  <h3 className="text-main-color font-poppins font-bold text-base mt-6">
                    ENTERPRISE PLAN
                  </h3>
                  <p className="font-roboto text-sm text-gray-600">
                    For full incrediable product feature
                  </p>
                </div>

                <div class="text-center xs:text-center sm:text-center lg-text-center lg:text-left mt-3 font-roboto">
                  <ul id="pricing" class=" text-sm text-black">
                    <li>
                      <span className="mr-4 text-check-mark text-base">✔</span>{" "}
                      <p>10.000 GB of free space</p>
                    </li>
                    <li>
                      {" "}
                      <span className="mr-4 text-check-mark text-base">
                        ✔
                      </span>{" "}
                      <p>30 days of free service</p>
                    </li>
                    <li>
                      <span className="mr-4 text-check-mark text-base">✔</span>{" "}
                      <p>All time support service 24/7</p>
                    </li>
                    <li>
                      <span className="no-underline mr-4 text-check-mark text-base">
                        ✔
                      </span>{" "}
                      <p>Access to free learning courses</p>
                    </li>
                    <li>
                      <span className="mr-4 text-check-mark text-base">✔</span>{" "}
                      <p>Certificate of project completion</p>
                    </li>
                    <li>
                      <span className="mr-4 text-check-mark text-base">✔</span>{" "}
                      <p>Advance loan payment feature</p>
                    </li>
                  </ul>
                </div>
                <button class="font-poppins w-full mt-6 mb-3 py-4 text-sm text-white font-semibold bg-main-color rounded-md hover:shadow-xl duration-200 hover:bg-gray-800">
                  <a href="#">GET STARTED</a>
                </button>
              </div>
            </div>
          </div>
        </section>
        {/* PRICING END HERE */}

        {/* COMPARE START HERE */}
        <section className="pb-28">
          <h2 className="text-heading-color text-4xl lg:pt-11 mb-16 font-bold text-center">
            LET'S COMPARE
          </h2>

          <div className="flex justify-center align-center font-poppins text-xs lg:text-xl p-4 lg:px-9">
            <table class="table-auto items sm:px-1">
              <thead>
                <tr>
                  <th className="text-center font-normal ">
                    <p className="border-dashed border-b-2 border-gray-300">
                      FEATURES
                    </p>
                  </th>
                  <th>
                    <p className="border bg-pricing-blue rounded-t-md font-normal text-white py-2 px-6">
                      FREE PLAN
                    </p>
                  </th>
                  <th>
                    {" "}
                    <p className="border bg-pricing-pink rounded-t-md font-normal text-white py-2 px-3">
                      PROFESSIONAL PLAN
                    </p>
                  </th>
                  <th>
                    {" "}
                    <p className="border bg-main-color rounded-t-md font-normal text-white py-2 px-3">
                      ENTERPRISE PLAN
                    </p>
                  </th>
                </tr>
              </thead>
              <br />
              <tbody className="mt-11">
                <tr className="border-b border-t">
                  <td className="text-left">Storage</td>
                  <td>5 Gb</td>
                  <td>1000 GB</td>
                  <td>10.000 GB</td>
                </tr>
                <tr className="border-b">
                  <td className="text-left">Resolution</td>
                  <td>Medium</td>
                  <td>High</td>
                  <td>4K</td>
                </tr>
                <tr className="border-b">
                  <td className="text-left">Branding Remove</td>
                  <td></td>
                  <td>
                    <img src="./img/check.png" alt="" />
                  </td>
                  <td>
                    <img src="./img/check2.png" alt="" />
                  </td>
                </tr>
                <tr className="border-b">
                  <td className="text-left">Privacy Control</td>
                  <td>5 GB</td>
                  <td>
                    <img src="./img/check.png" alt="" />
                  </td>
                  <td>
                    <img src="./img/check2.png" alt="" />
                  </td>
                </tr>
                <tr className="border-b">
                  <td className="text-left">24/7 Priority Support</td>
                  <td></td>
                  <td>
                    <img src="./img/check.png" alt="" />
                  </td>
                  <td>
                    <img src="./img/check2.png" alt="" />
                  </td>
                </tr>

                <tr className="border-b">
                  <td className="text-left">Advance Setting</td>
                  <td></td>
                  <td></td>
                  <td>
                    <img src="./img/check2.png" alt="" />
                  </td>
                </tr>
                <tr className="border-b">
                  <td className="text-left">Artificial Intelligence</td>
                  <td></td>
                  <td></td>
                  <td>
                    <img src="./img/check2.png" alt="" />
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td className="relative">
                    <button class="absolute right-0 top-0 font-poppins w-full mt-6 mb-3 py-4 text-xs text-white font-semibold bg-pricing-blue rounded-md hover:shadow-xl duration-200 hover:bg-gray-800">
                      <a href="#">START NOW</a>
                    </button>
                  </td>
                  <td>
                    <button class="font-poppins w-full mt-6 mb-3 py-4 text-xs text-white font-semibold bg-pricing-pink rounded-md hover:shadow-xl duration-200 hover:bg-gray-800">
                      <a href="#">START NOW</a>
                    </button>
                  </td>
                  <td className="relative">
                    <button class="lg:absolute left-8 top-0 font-poppins mt-6 mb-3 py-4 w-full lg:w-3/4 text-xs text-white font-semibold bg-main-color rounded-md hover:shadow-xl duration-200 hover:bg-gray-800">
                      <a href="#">START NOW</a>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
        {/* COMPARE END HERE */}

        {/* YOU ALSO GET SECTION START HERE */}
        <section className="pb-28 ">
          <h2 className="text-heading-color text-4xl pt-11 font-bold text-center">
            YOU ALSO GET
          </h2>

          <div className="m-auto flex flex-col justify-center px-6 lg:mx-12  text-gray-400 mt-11 relative overflow-x-hidden">
            <img className="w-full" src="./img/discount.png" alt="" />
            <div className="lg:mr-12 text-md lgtext-2xl text-white font-bold bg-black bg-opacity-20 text-center absolute w-10/12 lg:w-11/12 bottom-0 overflow-hidden">
              <p>
                DISCOUNT <span className="text-lg lg:text-3xl">30%</span> FOR 2
                MONTHS
              </p>
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </div>
  );
}

export default Pricing;
